// P2b tanda 3e (ajuste 4) — la confirmación de "Eliminar producto", UNA sola
// vez para los cuatro sitios que la usan (tarjeta, fila, panel lateral y
// ficha). Regla: nunca publicado (borrador/privado/pendiente) → borrado
// DEFINITIVO, que libera el SKU; publicado → papelera, donde el SKU queda
// ocupado (medido con #10895 el 13-sep-2026). La confirmación DICE cuál de las
// dos va a pasar; el servidor re-verifica el estado antes de permitir el
// definitivo.
export function confirmacionDeEliminar(nombre, status) {
  const definitivo = ['draft', 'private', 'pending'].includes(String(status || ''));
  const n = String(nombre || '').trim() || 'este producto';
  if (definitivo) {
    return {
      definitivo,
      title: 'Eliminar producto',
      confirmLabel: 'Eliminar definitivamente',
      message: `Vas a eliminar "${n}" definitivamente de WooCommerce. Nunca se publicó, así que no pasa por la papelera y su SKU queda libre de inmediato. Esta acción no se puede deshacer.`,
    };
  }
  return {
    definitivo,
    title: 'Eliminar producto',
    confirmLabel: 'Enviar a la papelera',
    // Tanda 4 (PARTE C): la papelera ahora se gestiona desde el propio
    // Catálogo — la salida del SKU ocupado ya no manda a WordPress.
    message: `Vas a enviar "${n}" a la papelera de WooCommerce. Queda recuperable; no se borra para siempre. Ojo: mientras esté en la papelera su SKU sigue ocupado — para reusarlo, restáuralo o elimínalo definitivamente desde la Papelera de Catálogo.`,
  };
}
